import React from "react";
import paths from "@icarius-router/paths";
import ScreenSelector from "@icarius-common/screenSelector";
import {
  GeneralValuesIcon,
  FamilyAsignationsIcon,
  RatingsIcon,
  TaxTableIcon,
} from "@icarius-icons/";
import { getLocalizedString } from "@icarius-localization/strings";

const RatingsAndGeneralValues = () => {

  const data = [
    {
      name: getLocalizedString("generalValuesUppercase"),
      icon: <GeneralValuesIcon />,
      path: paths.generalValues,
    },
    {
      name: getLocalizedString("familyAsignations"),
      icon: <FamilyAsignationsIcon />,
      path: paths.familyAsignations,
    },
    {
      name: getLocalizedString("ratings"),
      icon: <RatingsIcon />,
      path: paths.ratings,
    },
    {
      name: getLocalizedString("taxTable"),
      icon: <TaxTableIcon />,
      path: paths.taxTable,
    },
  ];

  return (
    <ScreenSelector
      title={getLocalizedString("ratingsAndGeneralValues")}
      data={data}
    />
  );
}

export default RatingsAndGeneralValues;